<template>
  <v-layout row wrap align-center justify-center>
    <v-flex xs12 sm6>
      <v-card>
        <v-card-title>
          <h1>{{ meta.title }}</h1>
        </v-card-title>
        <v-divider/>
        <v-card-text>
          <vue-form :state="auth" @submit.prevent="sendForm">
            <v-container fluid grid-list-xl>
              <v-layout wrap align-top justify-center>
                <v-flex xs12>
                  <validate>
                    <v-text-field
                      v-model="data.username"
                      name="login"
                      label="Login"
                      required
                      hide-details/>

                    <field-messages name="login" show="$dirty && $touched || $submitted">
                      <small class="error--text" slot="required">"Login" is a required field</small>
                    </field-messages>
                  </validate>
                </v-flex>

                <v-flex xs12>
                  <validate>
                    <v-text-field
                      v-model="data.password"
                      type="password"
                      name="password"
                      label="Password"
                      required
                      hide-details/>

                    <field-messages name="password" show="$dirty && $touched || $submitted">
                      <small class="error--text" slot="required">"Password" is a required field</small>
                    </field-messages>
                  </validate>
                </v-flex>
              </v-layout>
              <v-layout wrap align-top justify-end>
                <v-btn
                  :disabled="isSending"
                  :loading="isSending"
                  type="submit"
                  color="success">
                  Login
                </v-btn>
              </v-layout>
            </v-container>
          </vue-form>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import CurrentUser from '../orm/models/CurrentUser';
import STORE from '../store/STORE';

const { actions: currentUserActions } = STORE.modules.currentUser;

export default {
  data() {
    return {
      auth: {},
      data: {
        username: '',
        password: '',
      },
      isSending: false,
    };
  },
  methods: {
    async sendForm() {
      if (!this.auth.$valid) return;
      try {
        this.isSending = true;
        await CurrentUser.dispatch(`${currentUserActions.login}`, this.data);
        this.$router.push({ path: this.$route.query.from || '/' });
      } finally {
        this.isSending = false;
      }
    },
  },
  computed: {
    meta() {
      return this.$route.meta;
    },
  },
};
</script>
